<template>
    <div class="payment-history">
        <div class="payment-iocn payment-pending">
            <img src="@/assets/images/payment-processing.svg" alt="processing-payment" loading="lazy">
        </div>
        <div class="request_title">
            <h3>{{ walletDetails?.user_name }}</h3>
            <p>{{ walletDetails?.type==2 ? $t('deposit', 'Deposit') : $t('withdraw', 'Withdraw')}} {{$t('request-pending', 'Request Pending')}}</p>
        </div>
    </div>
</template>
<script>
export default {
    name: "DepositRequestApproved",
    props:['walletDetails'],
}
</script>